import React,{ Component } from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import FieldGroup from '../../../../components/FieldGroup';
import SelectWrap from "../../../../components/SelectWrap";
import countriesObj from "../../../../data/countries";
import { handleFieldChange } from "../../../../Utils";

const countriesOptions = Object.assign({ all: 'All' }, countriesObj);

class Filters extends Component {
    constructor(props) {
        super(props);

        this.state = {
            day: '',
            hour: '',
            country: '',
            source: ''
        };

        this.handleFieldChange = handleFieldChange.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
    }

    handleFormSubmit(e) {
        e.preventDefault();

        this.props.onSubmit(this.state);
    }

    render() {
        return (
            <form onSubmit={this.handleFormSubmit}>
                <Row>
                    <Col lg={6}>
                        <FieldGroup
                            type="date"
                            name="day"
                            label="Day:"
                            onChange={this.handleFieldChange}
                            value={this.state.day}
                            required
                        />
                    </Col>
                    <Col lg={6}>
                        <FieldGroup
                            type="number"
                            name="hour"
                            label="Hour:"
                            min={0}
                            max={23}
                            onChange={this.handleFieldChange}
                            value={this.state.hour}
                        />
                    </Col>
                    <Col lg={6}>
                        <SelectWrap
                            values={countriesOptions}
                            label="Countries:"
                            name="country"
                            onChange={this.handleFieldChange}
                            value={this.state.country}
                            multi
                        />
                    </Col>
                    <Col lg={6}>
                        <SelectWrap
                            values={this.props.sources}
                            label="Sources:"
                            name="source"
                            onChange={this.handleFieldChange}
                            value={this.state.source}
                            multi
                        />
                    </Col>
                </Row>

                <Button type="submit" bsStyle="info" className="m-b-15" >Apply</Button>
            </form>
        );
    }
}

export default Filters;


// WEBPACK FOOTER //
// ./src/scenes/BidderHourly/components/Form/index.js